import * as React from "react";
import { observer } from "mobx-react";
import { Tabs, Tab, Alert, Button, Alignment, FormGroup, Intent, NonIdealState, } from "@blueprintjs/core";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { IEmpresa } from "../../model";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";
import { formatCnpj } from "../../utils";
import { toast } from "react-toastify";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import ConfiguracaoImportacaoNfe from "./configuracao_nfe";
import ConfiguracaoImportacaoNfce from "./configuracao_nfce";
import ConfiguracaoImportacaoCte from "./configuracao_cte";
import ProdutosSped from "./produtos_sped";
import ProdutosGenericosSped from "./produtos_sped_generic";

@observer
export default class SpedEfdPage extends React.Component<any, {}> {
  obs = observable({
  })

  constructor(props: {}) {
    super(props);
  }

  handleLoadSpedEfd() {
    if (SpedEfdStore.obs.selectedEmpresa.cnpj == "") {
      toast.warning('Você precisa selecionar uma empresa para filtrar.', {});
      return
    }
    SpedEfdStore.obs.select_tab_geral = "produtos"
    SpedEfdStore.obs.tab_entrada_saida = "geral"
    SpedEfdStore.obs.select_config_saidas_tab = "opcoes"
    SpedEfdStore.obs.select_config_entradas_tab = "opcoes"

    SpedEfdStore.handleBuscaProdutos(SpedEfdStore.obs.selectedEmpresa.cnpj, 1, "")
    SpedEfdStore.handleLoadCST()

    SpedEfdStore.obs.isEmpresa = true
    SpedEfdStore.obs.open_select_empresa = false
  }

  async hanldeChangeTabGeral(tab: string) {

    if (tab == "produtos") {
      SpedEfdStore.obs.produtos_current = 1
      SpedEfdStore.obs.filter_produtos_sped = ""
      SpedEfdStore.resetDeletarItems();
      SpedEfdStore.handleBuscaProdutos(SpedEfdStore.obs.selectedEmpresa.cnpj, 1, "")
    }

    if (tab == "generic_produtos") {
      SpedEfdStore.obs.generic_produtos_current = 1
      SpedEfdStore.obs.generic_produtos_filter = ""
      SpedEfdStore.handleBuscaProdutosGenericos(SpedEfdStore.obs.selectedEmpresa.cnpj, 1, "")
    }

    SpedEfdStore.obs.select_tab_geral = tab;
    SpedEfdStore.obs.tab_entrada_saida = "geral";
  }

  render() {
    if (!SpedEfdStore.obs.isEmpresa) {
      return this.renderBlock();

    } else {
      return this.renderSped();

    }
  }

  renderBlock() {
    let empresaTextProg = SpedEfdStore.obs.selectedEmpresa.cnpj != ""
      ? `${SpedEfdStore.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(SpedEfdStore.obs.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    let titleEmpresaText = SpedEfdStore.obs.selectedEmpresa.cnpj != ""
      ? SpedEfdStore.obs.selectedEmpresa.razao_social + " - (" + formatCnpj(SpedEfdStore.obs.selectedEmpresa.cnpj) + ")"
      : "";

    return (
      <>
        <MDBCol>
          <MDBRow>
            <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => SpedEfdStore.obs.open_select_empresa = true}>Selecionar Empresa</MDBBtn>
            <h2 className="titleSEFAZ titleEmpresaSped">{titleEmpresaText}</h2>
          </MDBRow>
        </MDBCol>

        <div className="nz-non-ideal">
          <NonIdealState
            icon="box"
            description={"Selecione uma Empresa para realizar as Configurações"} />
        </div>

        <Alert
          cancelButtonText="Fechar"
          confirmButtonText="Carregar"
          isOpen={SpedEfdStore.obs.open_select_empresa}
          onClose={() => SpedEfdStore.obs.open_select_empresa = false}
          onConfirm={() => this.handleLoadSpedEfd()}
          className="AlertUser"
          canOutsideClickCancel={true}
          intent={Intent.PRIMARY}
        >
          <h2 className="titleSEFAZ">Selecione uma Empresa</h2>
          <FormGroup
            className="empresaSelect"
          >
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e: IEmpresa) => SpedEfdStore.obs.selectedEmpresa = e}
              inputProps={{ placeholder: "Filtrar uma empresa" }}
            >
              <Button
                text={empresaTextProg}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
              />
            </EmpresaSelect>
          </FormGroup>
        </Alert>
      </>
    );
  }

  renderSped() {
    let empresaTextProg = SpedEfdStore.obs.selectedEmpresa.cnpj != ""
      ? `${SpedEfdStore.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(SpedEfdStore.obs.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    let titleEmpresaText = SpedEfdStore.obs.selectedEmpresa.cnpj != ""
      ? SpedEfdStore.obs.selectedEmpresa.razao_social + " - (" + formatCnpj(SpedEfdStore.obs.selectedEmpresa.cnpj) + ")"
      : "";

    return (
      <>
        <MDBCol>
          <MDBRow>
            <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => SpedEfdStore.obs.open_select_empresa = true}>Selecionar Empresa</MDBBtn>
            <h2 className="titleSEFAZ titleEmpresaSped">{titleEmpresaText}</h2>
          </MDBRow>
        </MDBCol>

        <Tabs
          id="tabs"
          className={"tabsCalculos"}
          data-tut="resumo"
          selectedTabId={SpedEfdStore.obs.select_tab_geral}
          onChange={(tabId) => this.hanldeChangeTabGeral(String(tabId))}
        >

          <Tab
            id="produtos"
            title="Produtos Sped"
            panel={<ProdutosSped />}
          />

          <Tab
            id="generic_produtos"
            title="Produtos Genéricos"
            panel={<ProdutosGenericosSped />}
          />

          <Tab
            id="nfe"
            title="Configuração de NF-e"
            panel={<ConfiguracaoImportacaoNfe />}
          />
          <Tab
            id="cte"
            title="Configuração de CT-e, e CT-e OS"
            panel={<ConfiguracaoImportacaoCte />}
          />

          <Tab
            id="nfce"
            title="Configuração de NFC-e"
            panel={<ConfiguracaoImportacaoNfce />}
          />

        </Tabs>

        <Alert
          cancelButtonText="Fechar"
          confirmButtonText="Carregar"
          isOpen={SpedEfdStore.obs.open_select_empresa}
          onClose={() => SpedEfdStore.obs.open_select_empresa = false}
          onConfirm={() => this.handleLoadSpedEfd()}
          className="AlertUser"
          canOutsideClickCancel={true}
          intent={Intent.PRIMARY}
        >
          <h2 className="titleSEFAZ">Selecione uma Empresa</h2>
          <FormGroup
            className="empresaSelect"
          >
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e: IEmpresa) => SpedEfdStore.obs.selectedEmpresa = e}
              inputProps={{ placeholder: "Filtrar uma empresa" }}
            >
              <Button
                text={empresaTextProg}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
              />
            </EmpresaSelect>
          </FormGroup>
        </Alert>
      </>
    );
  }
}